import React from 'react';
import { QueryResult, useQuery } from '@apollo/client';
import { fetchCreatedSubscriptionsForTransactionAccount } from './queries/fetch-created-subscription-for-transaction-account';
import { MAX_WIDGET_ITEMS } from '../../../constants/widget';
import {
  FetchCreatedSubscriptionsForTransactionAccountQuery,
  FetchCreatedSubscriptionsForTransactionAccountQueryVariables,
  SortDirection,
} from '@css-xp/graphtypes/src/generated-types-new';

type ChildrenProp = (
  args: QueryResult<
    FetchCreatedSubscriptionsForTransactionAccountQuery,
    FetchCreatedSubscriptionsForTransactionAccountQueryVariables
  >
) => JSX.Element;

export const SubscriptionCreatedQueryWrapper = ({
  txaId,
  children,
}: {
  txaId: string;
  children: ChildrenProp;
}): JSX.Element => {
  const queryResult = useQuery<
    FetchCreatedSubscriptionsForTransactionAccountQuery,
    FetchCreatedSubscriptionsForTransactionAccountQueryVariables
  >(fetchCreatedSubscriptionsForTransactionAccount, {
    variables: {
      id: txaId,
      searchOptions: {
        first: MAX_WIDGET_ITEMS,
        sort: {
          sortFields: ['createdDate', 'id'],
          sortFieldsDirections: [SortDirection.DESC, SortDirection.ASC],
        },
      },
      filterOptions: [
        {
          key: 'not',
          // fetching only the subscriptions which are not app or sandbox type
          value:
            '[{"relatesFromEntitlementsRelationshipType":"ADDON_DEPENDENCE"},' +
            '{"relatesFromEntitlementsRelationshipType":"APP_DEPENDENCE"},' +
            '{"relatesFromEntitlementsRelationshipType":"SANDBOX_DEPENDENCE"}]',
        },
        {
          key: 'status',
          // fetching only the subscriptions which are active currently
          value: 'Active',
        },
      ],
    },
    skip: !txaId,
    fetchPolicy: 'cache-and-network',
  });
  return children(queryResult);
};
